<template>
    <div class="addstu">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes">
          <div class="contianer">
            <div class="title">学员信息</div>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
              <el-form-item label="姓名" prop="nickname">
                <el-input v-model="form.nickname" maxlength="10" placeholder="输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="出生日期" prop="birth_date">
                <el-date-picker type="date"  v-model="form.birth_date" placeholder="选择日期" style="width: 100%;"  ></el-date-picker>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                 <el-select v-model="form.sex"  placeholder="请选择学生性别" style="width: 100%;">
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="监护人电话" prop="mobile">
                 <el-input v-model="form.mobile" placeholder="监护人电话" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="监护人姓名">
                <el-input v-model="form.real_name" maxlength="10" placeholder="监护人姓名"></el-input>
              </el-form-item>
              <el-form-item label="关系" prop="relationship">
                 <el-select v-model="form.relationship" placeholder="监护人与学生关系" style="width: 100%;">
                  <el-option label="其它" value="9"></el-option>
                  <el-option label="阿姨" value="7"></el-option>
                  <el-option label="奶奶" value="4"></el-option>
                  <el-option label="爷爷" value="3"></el-option>
                  <el-option label="姥姥" value="6"></el-option>
                  <el-option label="姥爷" value="5"></el-option>
                  <el-option label="母亲" value="2"></el-option>
                  <el-option label="父亲" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年龄" prop="age">
                 <el-input v-model="form.age" placeholder="5岁10月" readonly></el-input>
              </el-form-item>
              <el-form-item label="意向" prop="intention">
                <el-radio-group v-model="form.intention">
                 <el-radio :label="1">有意向</el-radio>
                 <el-radio :label="2">无意向</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="备注：" prop="remark">
                <el-input v-model="form.remark" type="textarea" maxlength="300" placeholder="输入备注内容"></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-button type="primary" @click="submitForm('form')">保存信息</el-button>
                <el-button><router-link to="/table">进入测评</router-link></el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
    </div>
</template>
<script>
import { calculateAge } from '@/utils/util'
import { userAdd, getUserDetail, userEditMultiple } from '@/api/app'
import { Loading } from 'element-ui'
export default {
  name: 'AddStudent',
  data () {
    return {
      loadingInstance: null,
      model: 'add',
      column: '新增学员',
      form: {
        nickname: '',
        birth_date: '',
        sex: '',
        mobile: '',
        real_name: '', // 监护人姓名
        relationship: '',
        age: '',
        remark: '',
        intention: 1
      },
      rules: {
        nickname: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ],
        birth_date: [
          { required: true, message: '请选择学生出生日期', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择学生性别', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入监护人电话', trigger: 'blur' }
        ],
        relationship: [
          { required: true, message: '请选择学生关系', trigger: 'blur' }
        ]/* ,
        age: [
          { required: true, message: '年龄自动生成', trigger: 'blur' }
        ] */
      }
    }
  },
  watch: {
    'form.birth_date': function (newVal, oldVal) {
      this.form.age = calculateAge(newVal)
      // console.log('birth_date changed from:[', oldVal, '] to:[', newVal, ']')
    }
    /* ,
    form: {
      handler (newVal, oldVal) {
        console.log('Form changed:', newVal)
      },
      deep: true
    } */
    /* birth_date (newDate) {
      console.log(newDate)
      this.calculateAge(newDate)
    } */
  },
  mounted () {
    // console.log(this.$route.query)
    if (this.$route.query.id) {
      this.model = 'edit'
      this.getDetail()
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    async getDetail () {
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      const detail = getUserDetail({id: this.$route.query.id})
      let that = this
      detail.then(function (data) {
                // 在这里处理数据
                // console.log('===client:==', data)
                that.form = data
                that.loadingInstance && that.loadingInstance.close()
                // that.$router.push('/mystudents') // goBack()
            }).catch(function (error) {
                // 在这里处理错误3
                console.log('===error:==', error)
            })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    /* enter () {
      this.$router.push({ nickname: 'track' })
    }, */
    submitForm (formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!')
            // 显示加载层
            this.loadingInstance = Loading.service({ fullscreen: true })
            const waitOk = that.model === 'add' ? userAdd(this.form) : userEditMultiple(this.form)
            // console.log(waitOk)
            waitOk.then(function (data) {
                // 在这里处理数据
                // console.log('===client:==', data)
                that.$router.push('/mystudents') // goBack()
                that.loadingInstance && that.loadingInstance.close()
            }).catch(function (error) {
                // 在这里处理错误3
                console.log('===error:==', error)
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
  }
}
</script>
<style>
.addstu{
  min-height: 100vh;
  /* background: #efefef; */
}
.addstu .avatar {
  width: 100%;
  background: linear-gradient(90deg, #ff9b00, #accd05);
  padding: 1rem 0;
}
.addstu .avatar .dfx{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.addstu .avatar .column{
  flex: 1;
  text-align: center;
  font-size: 1.13rem;
  font-weight: bold;
  color: #fff;
}
.addstu .asstes .contianer{
  margin: 5% 23% 5%;
  background: #fff;
  /* padding: 1.13rem; */
  border-radius: 1.13rem;
  padding-bottom: 68px;
}
.addstu .asstes .title{
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 4rem;
  border-bottom:1px solid #dedede;
}
.addstu .asstes .el-form{
  width: 100%;
  background: #fff;
  border: none;
}
.addstu .asstes .el-form .el-form-item{
  border-bottom:1px solid #dedede;
  margin-bottom: 0;
}
.addstu .asstes .el-form .el-form-item .el-form-item__label{
  width: 7.35rem !important;
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 4rem;
  text-align: left;
  position: relative;
  color: #000;
  padding-left: 12px;
  padding-right: 0;
}
.addstu .asstes .el-form .el-form-item .el-form-item__label::before{
  position: absolute;
  top: 0;
  left: -3px;
}
/* .addstu .asstes .el-form .el-form-item .el-form-item__label::after{
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
  line-height: 4rem;
} */
.addstu .asstes .el-form .el-form-item .el-form-item__content{
  margin-left: 7.35rem !important;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-textarea__inner{
  padding-top: 1.4rem;
  height: 4rem;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-input{
  line-height: 4rem;
}
.addstu .asstes .el-form .btn .el-form-item__content{
  text-align: center;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button{
    width: 11.13rem;
    height: 2rem;
    border: 0;
    padding: 0;
    margin-top: 2.5rem;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button span,
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button span a{
  font-size: 1rem;
  color: #fff;
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button--primary{
  background: linear-gradient(0deg,#81B337,#ACCD05);
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-button--default{
  background: linear-gradient(0deg,#FF9C00,#FF7200);
}
.addstu .asstes .el-form .el-form-item .el-form-item__content .el-radio-group{
  height: 4rem;
  display: flex;
  align-items: center;
}
.addstu .asstes .el-form .el-input__inner,
.addstu .asstes .el-form .el-textarea__inner{
  border:0;
}
.addstu .asstes .el-form .btn{
  border-bottom:  0;
}
.addstu .asstes .el-form .btn .el-form-item__content{
  margin-left: 0 !important;
}

@media (max-width:1024px) {
 .addstu .asstes .contianer {
  margin: 5% auto 5%;
 }
}
.el-form-item__error{
  z-index: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/AddStudent.vue